<template>
  <div
    :content="$vt('Open presets panel')"
    v-tippy="{ placement: 'left', arrow: true, delay: [130, 0] }"
    class="vstudio20-presets-closed v17-panel"
    v-on:click="$emit('open')"
    role="button"
  >
    <div class="head">
      <i class="fa fa-sliders"></i>
    </div>
    <div class="preset-body">
      <i class="fa fa-expand"></i>
    </div>
  </div>
</template>
<script>
export default {
  translate25Context: 'vstudio20_presets'
};
</script>

<style lang="scss">
.vstudio20-presets-closed {
  opacity: 1;
  width: 40px;

  height: 100%;
  margin-left: 10px;

  .preset-body .fa {
    visibility: hidden;
    opacity: 0;

    transition: opacity 125ms ease;
  }

  &:hover .preset-body .fa {
    visibility: visible;
    opacity: 1;
  }

  .head {
    border-bottom: solid 5px #f2f2f2;
    justify-content: center;
    padding: 15px 0;
    // padding: initial 0px ;
  }

  .preset-body {
    padding: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    transition: bakground-color 125ms ease;

    &:hover {
      background-color: rgba(215, 243, 241, 0.25);
    }
  }

  &.v-enter-active,
  &.v-leave-active {
    transition: 125ms ease;
    transition-property: opacity width;
  }

  &.v-enter,
  &.v-leave-to {
    opacity: 0;
    width: 350px;
  }
}

.dark-mode {
  .vstudio20-presets-closed {
    background-color: var(--black);
      color: var(--white-a75);

    .head {
      border-bottom: solid 5px #404040;
      color: var(--white-a75);
    }

    .preset-body
    {
      color: var(--white-a75);
    }
  }
}
</style>